import { Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "app-tab",
	templateUrl: "./tab.component.html",
	styleUrls: ["./tab.component.scss"],
})
export class TabComponent {
	@Input()
	label: string;

	@Input()
	selected = true;

	@Input()
	tabIndexValue: number | null = null;

	@Output()
	selectTab = new EventEmitter();

	constructor(private elementRef: ElementRef) {}

	onClick() {
		this.selected = true;

		this.selectTab.emit();
	}

	onSpaceKey(event: KeyboardEvent) {
		// Prevent the browser default (page scroll)
		event.preventDefault();
		this.onClick();
	}

	focus() {
		const el = this.elementRef.nativeElement.querySelector('[role="tab"]');
		if (el) {
			el.focus();
		}
	}
}
